import {validateCustomFormat} from "custom-format-validator";

export function validateCompanyVatId(companyVatId, billingCountry, countries, isCompanyChecked) {
  if (isCompanyChecked) {
    let valid = true;

    if (countries) {
      const country = countries.find(i => i.uuid === billingCountry);
      if (country) {
        valid = validateCustomFormat(companyVatId, country.vatNumberFormats, false);
      } else {
        valid = false;
      }
    }

    if (!companyVatId.length) {
      valid = false;
    }

    return valid;
  }

  return true;
}
